<template>
  <base-section id="venue">
    <v-container>
      <base-section-heading
        title="Conference Venue and Accommodation"
        color="secondary"
        align="left"
        :toColor="true"
        :space="6"
      />

      <div class="venue-content text-body-1">
        <h2 class="text-h5 font-weight-bold mb-4">Casa Andina Premium Miraflores</h2>

        <p>
          LATS 2027 will take place at <strong>Casa Andina Premium Miraflores</strong>,
          which will serve as the symposium venue and primary accommodation for attendees.
          Located in the heart of Miraflores, the hotel offers meeting facilities and easy
          access to Lima’s restaurants, shops, and Pacific coast—an inviting setting for
          technical discussions and exploring the city.
        </p>

        <v-alert
          border="left"
          colored-border
          color="primary"
          elevation="2"
          class="my-6"
        >
          <strong>LATS 2027</strong> will take place in <strong>Lima, Peru</strong>,
          from <strong>April 13 to 16, 2027</strong>.
        </v-alert>

        <p><strong>Address:</strong> Av. La Paz 463, Miraflores, Lima, Peru.</p>

        <v-btn
          :href="hotelWebsiteUrl"
          target="_blank"
          rel="noopener noreferrer"
          rounded
          large
          color="primary"
          class="venue-link mb-6"
        >
          <v-icon left>mdi-open-in-new</v-icon>
          Visit Official Hotel Website
        </v-btn>

        <v-divider class="mb-6" />

        <h2 class="text-h5 font-weight-bold mb-4">Hotel Location</h2>

        <figure class="venue-location mb-6">
          <a
            :href="googleMapsUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              :src="require('@/images/venue/casa-andina-premium-miraflores-location.png')"
              alt="Map showing Casa Andina Premium Miraflores in Lima, Peru, near the Pacific coast."
              width="1352"
              height="830"
              loading="lazy"
              class="venue-map"
            >
          </a>
          <figcaption class="mt-3">Panoramic view of the venue hotel location.</figcaption>
        </figure>

        <v-btn
          :href="googleMapsUrl"
          target="_blank"
          rel="noopener noreferrer"
          rounded
          large
          outlined
          color="primary"
          class="venue-link"
        >
          <v-icon left>mdi-map-marker</v-icon>
          View Hotel Location on Google Maps
        </v-btn>
      </div>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: 'ConferenceVenue',

  data: () => ({
    hotelWebsiteUrl: 'https://www.casa-andina.com/es/destinos/miraflores/hoteles/casa-andina-premium-miraflores',
    googleMapsUrl: 'https://www.google.com/maps/search/?api=1&query=Casa+Andina+Premium+Miraflores%2C+Av.+La+Paz+463%2C+Miraflores%2C+Lima%2C+Peru',
  }),
}
</script>

<style scoped>
.venue-content {
  color: black;
}

.venue-location {
  margin: 0;
}

.venue-map {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 4px;
}

.venue-link {
  max-width: 100%;
  height: auto !important;
  min-height: 44px;
  padding: 12px 20px !important;
}

.venue-link ::v-deep .v-btn__content {
  white-space: normal;
}

@media (max-width: 600px) {
  .venue-link {
    width: 100%;
  }
}
</style>
